<template>
    <div
        class="toggle-picker"
        :class="stateClass"
        @touchstart="touchStart"
        @touchmove="touchMove"
    >
        <div
            tabindex="0"
            class="toggle-picker__option toggle-picker__option--start"
            @click="emit('updateValue', leftOption.value)"
            @keydown="keydown"
        >
            <span class="toggle-picker__option-label">
                {{ leftOption.label }}
            </span>
        </div>

        <div class="toggle-picker__button">
            <zoe-atom-media
                v-if="mediaIsNotEmpty(handleIcon)"
                class="toggle-picker__button-icon"
                :item="handleIcon"
            />
            <svg
                v-else
                class="toggle-picker__button-icon"
                x="0px"
                y="0px"
                viewBox="0 0 43 43"
                xml:space="preserve"
            >
                <g class="arrow toggle-picker-arrow-1">
                    <path d="M15.5678759,25.5242577v-8.0485153c0-1.2624493-1.5263119-1.8946524-2.4190035-1.002002 l-4.0242577,4.0242996c-0.5533857,0.5533447-0.5533857,1.4505768,0,2.0039215l4.0242577,4.024299 C14.041564,27.4189091,15.5678759,26.7867069,15.5678759,25.5242577z"/>
                    <path d="M27.4321251,25.5242577v-8.0485153c0-1.2624493,1.5263119-1.8946524,2.4190025-1.0020027l4.0242577,4.024299 c0.5533867,0.5533447,0.5533867,1.4505768,0,2.0039215l-4.0242577,4.024299 C28.958437,27.4189091,27.4321251,26.7867069,27.4321251,25.5242577z"/>
                </g>
            </svg>
        </div>

        <div
            tabindex="0"
            class="toggle-picker__option toggle-picker__option--end"
            @click="emit('updateValue', rightOption.value)"
            @keydown="keydown"
        >
            <span class="toggle-picker__option-label">
                {{ rightOption.label }}
            </span>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { mediaIsNotEmpty } from '../../../../../resources/frontend/js/mixins/get-page-data';
import ZoeAtomMedia from '@atoms/media/v1.0.0/zoe-atom-media.vue';

const emit = defineEmits(['updateValue']);
const props = defineProps({
    value: {
        type: String,
        required: true,
    },

    leftOption: {
        type: Object,
        required: true,
    },

    rightOption: {
        type: Object,
        required: true,
    },

    handleIcon: {
        type: String,
        default: '//',
    },
});

let xDown = null;
let yDown = null;

const stateClass = computed(() => {
    if (props.value === props.leftOption.value) {
        return 'toggle-picker--start';
    }

    if (props.value === props.rightOption.value) {
        return 'toggle-picker--end';
    }

    return '';
});

const keydown = event => {
    if (event.code === 'Space' || event.code === 'Enter') {
        event.preventDefault();
        event.target.click();
    }
};

const touchStart = event => {
    xDown = event.touches[0].clientX;
    yDown = event.touches[0].clientY;
};

const touchMove = event => {
    if (!xDown || !yDown) return;

    const xDiff = xDown - event.touches[0].clientX;
    const yDiff = yDown - event.touches[0].clientY;

    if (Math.abs(xDiff) + Math.abs(yDiff) > 50 && Math.abs(xDiff) > Math.abs(yDiff)) {
        const value = xDiff > 0 ? props.leftOption.value : props.rightOption.value;
        emit('updateValue', value);

        xDown = null;
        yDown = null;
    }
};
</script>

<style lang="scss">
@use 'zoe-molecule-toggle-picker';
</style>
